<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:44:54
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-08 19:42:42
 * @Description: file content
-->
<template>
  <div style="background-color: #f1f2f3">
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <v-nav></v-nav>
      </div>
    </div>
    <div class="mainContent clearfix bsznItem ywtbItem">
      <div class="mainWidth">
        <div class="overView clearfix">
          <div class="guideline-wrap" ref="sticky-ref">
            <h2>{{ guidelineData.portalPcHandlingGuidelineName }}</h2>
            <div class="bsScore clearfix">
              <div
                class="setScore clearfix pull-left"
                @click="pjFunc"
                style="position: relative"
                v-if="guidelineData.portalPcHandlingGuidelineSuggestion === 1"
              >
                <el-rate
                  v-model="value"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}"
                  style="font-size: 22px"
                >
                </el-rate>
                <div
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    cursor: pointer;
                  "
                ></div>
              </div>
              <div
                class="scoreText pull-left"
                v-if="guidelineData.portalPcHandlingGuidelineSuggestion === 1"
              >
                <a style="color: #eb3434; font-weight: 700" href="javascript:;"
                  >{{ pjNum }}&nbsp;</a
                >条评价
              </div>
              <div
                class="ywtbCollection pull-left noselect"
                @click="collection()"
                v-if="$store.state.isLogin"
              >
                <i
                  class="iconfont icon-sc"
                  :class="{ active: isCollection }"
                ></i
                ><span v-if="isCollection">&nbsp;&nbsp;取消收藏</span
                ><span v-if="!isCollection">&nbsp;&nbsp;收藏</span>
              </div>
              <!-- <div class="btnGroup">
                <a
                  v-if="
                    [null, undefined, ''].indexOf(
                      guidelineData.portalPcHandlingGuidelineUrl
                    ) === -1 && guidelineData.ljbl === 1
                  "
                  :href="guidelineData.portalPcHandlingGuidelineUrl"
                  class="btn btn-primary blBtn"
                  target="_blank"
                  style="display: block"
                  @click="
                    globalAddVisit(guidelineData.portalPcHandlingGuidelineCode)
                  "
                  >立即办理</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-primary pjBtn"
                  @click="goBack()"
                  >返回上一页</a
                >
              </div> -->
              <div class="btn-wrap">
                <a
                  href="javascript:;"
                  class="btn btn-primary pjBtn"
                  @click="goBack()"
                  >返回</a
                >
                <a
                  href="javascript:;"
                  class="btn btn-primary pjBtn"
                  v-if="guidelineData.portalPcHandlingGuidelineConsultation"
                  @click="goToZx()"
                  >咨询</a
                >
                <a
                  v-if="
                    [null, undefined, ''].indexOf(
                      guidelineData.portalPcHandlingGuidelineUrl
                    ) === -1 && guidelineData.ljbl === 1
                  "
                  :href="guidelineData.portalPcHandlingGuidelineUrl"
                  class="btn btn-primary blBtn"
                  target="_blank"
                  style="display: block"
                  @click="
                    globalAddVisit(guidelineData.portalPcHandlingGuidelineCode)
                  "
                  >立即办理</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="bsContent" style="margin-top: 10px">
          <!-- <ul
            class="bsTab clearfix"
            :class="{'is_fixed' : isFixed}"
          >
            <li
              v-for="(item,index) in guideNav"
              :key="index"
              :class="{active:guideIndex == index}"
              @click="guideNavClick(index)"
            >{{item.name}}</li>
          </ul> -->
          <h2 class="bsznTit clearfix">
            <i class="iconfont icon-jibenxinxi"></i>
            <span>基本信息</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2>
          <div class="content content0 active jbxx">
            <table class="table table-bordered">
              <tbody>
                <!-- <tr>
                  <td>事项类型</td>
                  <td>{{guidelineData.pcGuidelineTypeName}}</td>
                  <td>服务类型</td>
                  <td>{{guidelineData.fwlx}}</td>
                </tr> -->
                <tr>
                  <td>主办部门</td>
                  <td>{{ guidelineData.department || "-" }}</td>
                  <td>协办部门</td>
                  <td>{{ guidelineData.xbbm || "-" }}</td>
                </tr>
                <tr>
                  <td>受理人</td>
                  <td>{{ guidelineData.memberNickname || "-" }}</td>
                  <td>咨询电话</td>
                  <td>
                    {{ guidelineData.portalPcHandlingGuidelinePhone || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>受理地点</td>
                  <td>
                    {{
                      guidelineData.portalPcHandlingGuidelineOfficeLocation ||
                      "-"
                    }}
                  </td>
                  <td>受理时间</td>
                  <td>
                    {{
                      guidelineData.portalPcHandlingGuidelineOfficeTime || "-"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>办理时限</td>
                  <td>
                    {{
                      guidelineData.portalPcHandlingGuidelineOfficeTimeLimit ||
                      "-"
                    }}
                  </td>
                  <td>办理方式</td>
                  <td
                    v-if="
                      guidelineData.portalPcHandlingGuidelineOfficeType == 0
                    "
                  >
                    线上办理
                  </td>
                  <td
                    v-if="
                      guidelineData.portalPcHandlingGuidelineOfficeType == 1
                    "
                  >
                    网上审批，线下办理
                  </td>
                  <td
                    v-if="
                      guidelineData.portalPcHandlingGuidelineOfficeType == 2
                    "
                  >
                    线下办理
                  </td>
                  <td
                    v-if="
                      guidelineData.portalPcHandlingGuidelineOfficeType == null
                    "
                  >
                    -
                  </td>
                </tr>
                <tr>
                  <td>是否收费</td>
                  <td v-if="guidelineData.portalPcHandlingGuidelineCharge == 0">
                    否
                  </td>
                  <td v-if="guidelineData.portalPcHandlingGuidelineCharge == 1">
                    是
                  </td>
                  <td
                    v-if="guidelineData.portalPcHandlingGuidelineCharge == null"
                  >
                    -
                  </td>
                  <td>收费标准</td>
                  <td>
                    {{
                      guidelineData.portalPcHandlingGuidelineChargingStandard ||
                      "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2
            class="bsznTit clearfix"
            v-if="guidelineData.portalPcHandlingGuidelineGuideline"
          >
            <i class="iconfont icon-shuoming1"></i>
            <span>事项说明</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2>
          <div
            class="content content1 text w-e-text-container w-e-text"
            v-if="guidelineData.portalPcHandlingGuidelineGuideline"
            v-html="guidelineData.portalPcHandlingGuidelineGuideline"
          ></div>
          <!-- <h2 class="bsznTit clearfix">
            <i class="iconfont icon-liucheng"></i>
            <span>办理流程</span>
            <img src="../../assets/images/arrow_up.png" title="收起">
          </h2>
          <div class="content content2" v-html="guidelineData.portalPcHandlingGuidelineGuideline">
            <div class="nullData bllc_null" v-if="!guidelineData.portalPcHandlingGuidelineGuideline">
              <img src="../../assets/images/null.png" alt="">
              <p>暂无办理流程</p>
            </div>
          </div> -->
          <h2
            class="bsznTit clearfix"
            v-if="
              guidelineData.attachmentList &&
              guidelineData.attachmentList.length
            "
          >
            <i class="iconfont icon-xiazai1"></i>
            <span>资料下载</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2>
          <div
            class="content content3"
            v-if="
              guidelineData.attachmentList &&
              guidelineData.attachmentList.length
            "
          >
            <table class="table table-bordered fileDownload">
              <tbody>
                <tr>
                  <td>序号</td>
                  <td>材料名称</td>
                  <td>填报须知</td>
                  <td>材料下载</td>
                </tr>

                <tr
                  v-for="(item, index) in guidelineData.attachmentList"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.pcHandlingGuidelineAttachmentName }}</td>
                  <td>{{ item.pcHandlingGuidelineAttachmentNotice }}</td>
                  <td>
                    <span
                      v-if="item.pcHandlingGuidelineAttachmentPath !== ''"
                      @click="
                        downloadFile(
                          item.pcHandlingGuidelineAttachmentName,
                          item.pcHandlingGuidelineAttachmentPath
                        )
                      "
                      >点击下载</span
                    >
                    <!-- 点击下载 -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="nullData cl_null">
              <img src="../../assets/images/null.png" alt="" />
              <p>暂无材料</p>
            </div>
          </div>
          <h2
            class="bsznTit clearfix"
            v-if="guidelineData.portalPcHandlingGuidelineFileRule"
          >
            <i class="iconfont icon-baozhang1"></i>
            <span>文件规定</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2>
          <div
            class="content content5 text w-e-text-container w-e-text"
            v-if="guidelineData.portalPcHandlingGuidelineFileRule"
          >
            <div v-html="guidelineData.portalPcHandlingGuidelineFileRule"></div>
          </div>
          <h2
            class="bsznTit clearfix"
            v-if="
              guidelineData.knowledgeList && guidelineData.knowledgeList.length
            "
          >
            <i class="iconfont icon-changjianwenti1"></i>
            <span>常见问题</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2>
          <div
            class="content content6"
            v-if="
              guidelineData.knowledgeList && guidelineData.knowledgeList.length
            "
          >
            <div
              v-for="(item, index) in guidelineData.knowledgeList"
              :key="index"
            >
              <div class="que">
                问题：{{ item.portalPcGuidelineKnowledgeQuestion }}
              </div>
              <div class="ans">
                回答：{{ item.portalPcGuidelineKnowledgeAnswer }}
              </div>
            </div>
            <div class="nullData bllc_null" v-if="!guidelineData.knowledgeList">
              <img src="../../assets/images/null.png" alt="" />
              <p>暂无办理流程</p>
            </div>
          </div>
          <!-- <h2
            class="bsznTit clearfix"
            v-if="guidelineData.portalPcHandlingGuidelineConsultation"
          >
            <i class="iconfont icon-youkeduantubiao_zixun"></i>
            <span>我要咨询</span>
            <img src="../../assets/images/arrow_up.png" title="收起" />
          </h2> -->
          <div
            class="content content4"
            v-if="guidelineData.portalPcHandlingGuidelineConsultation"
          >
            <!-- <h3 class="zixunTit clearfix" style="display: none">
              <span>历史咨询</span>
              <a href="javascript:;" style="display: none">我要咨询</a>
            </h3> -->
            <div class="zxContent">
              <ul>
                <!-- <li>
                        <h4><span>1、十一期间能够去学校办理助学贷款吗？</span><b onclick="checkReplay(this)">展开</b></h4>
                        <div class="replayContent">
                          <div class="rep"><span>回复：</span>可以</div>
                          <div class="ask"><span>追问：</span>是工作时间吗？</div>
                          <a href="javascript:;" class="replayBtn" onclick="zxRepay(0)">回复</a>
                        </div>
                      </li>
                      <li>
                        <h4><span>2、十一期间能够去学校办理助学贷款吗？</span><b>待回复</b></h4>
                      </li>
                      <li>
                        <h4><span>3、十一期间能够去学校办理助学贷款吗？</span><b>处理中</b></h4>
                      </li> -->
              </ul>
              <div class="page">
                <ul id="pagination0"></ul>
              </div>
            </div>
            <!-- <div class="fqzx">
              <h3 class="zixunTit" style="display: none">发起咨询</h3>
              <textarea
                cols="130"
                maxlength="250"
                rows="5"
                placeholder="请输入咨询内容"
                id="zxTextarea"
                v-model="zxText"
              ></textarea>
              <div>
                <el-alert type="warning" :closable="false"
                  >注意事项：咨询及回复内容可在个人中心-一网通办中查看，提交后的问题无法删除</el-alert
                >
              </div>
              <div>
                <el-checkbox v-model="sfyd">我已阅读注意事项</el-checkbox>
              </div>
              <a
                href="javascript:;"
                class="btn btn-success"
                id="zxSubmit"
                @click="zxSubmit()"
                >我要咨询</a
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <v-footer :hasInfo="1"></v-footer>
    <v-toolBar></v-toolBar>
    <el-dialog :visible.sync="dialogVisible" title="事项评价" width="800px">
      <div>
        <Table
          :tableData="tableData"
          :theadData="theadData"
          :hasCheck="false"
          border
        >
          <template v-slot:pjnr="{ scope }">
            <div>
              <span
                v-if="scope.row.pcHandlingGuidelineSuggestionTop"
                class="zd_class"
                >置顶</span
              >
              <span>{{
                scope.row.pcHandlingGuidelineSuggestionSuggestion || "-"
              }}</span>
            </div>
          </template>
          <template v-slot:pjxj="{ scope }">
            <el-rate
              :value="scope.row.pcHandlingGuidelineSuggestionSatisfaction"
              disabled
              text-color="#ff9900"
              score-template="{value}"
            >
            </el-rate>
          </template>
        </Table>
      </div>
      <div style="text-align: center; padding-top: 10px" v-if="totalSize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 咨询弹框 -->
    <el-dialog
      title="我要咨询"
      :visible.sync="zxDialogVisible"
      width="600px"
      class="dialog"
      style="font-size: 12px"
    >
      <textarea
        cols="130"
        maxlength="250"
        rows="5"
        placeholder="请输入咨询内容"
        id="zxTextarea"
        v-model="zxText"
      ></textarea>
      <div style="font-size: 12px">
        <el-checkbox v-model="sfyd" style="font-size: 12px"
          >我已阅读注意事项：咨询及回复内容可在个人中心-一网通办中查看，提交后的问题无法删除</el-checkbox
        >
      </div>
      <a
        href="javascript:;"
        class="btn btn-success btn-zx"
        id="zxSubmit"
        @click="zxSubmit()"
        >我要咨询</a
      >
    </el-dialog>
  </div>
</template>

<script>
import Footer from "../common/Footer";
import Header from "../common/Header";
import TopNav from "../common/TopNav";
import ToolBar from "../common/ToolBar";
import Table from "@/components/table/table.vue";
import qs from "qs";
import { ywtbRequest, request } from "@/api/axios";
export default {
  components: {
    "v-footer": Footer,
    "v-header": Header,
    "v-nav": TopNav,
    "v-toolBar": ToolBar,
    Table,
  },
  data() {
    return {
      guidelineId: "",
      // 事项code
      guidelineCode: "",
      navIndex: "",
      zxText: "",
      guideNav: [
        // {
        //   name: '基本信息'
        // },
        // {
        //   name: '事项说明'
        // },
        // {
        //   name: '资料下载'
        // },
        // {
        //   name: '文件规定'
        // },
        // {
        //   name: '常见问题'
        // },
        // {
        //   name: '我要咨询'
        // }
      ],
      znDom: "",
      guideIndex: 0,
      value: 5,
      isFixed: false, //左边栏是否固定到顶部
      bsTabOffsetTop: 260,
      oLeft: 0,
      guidelineData: "",
      isCollection: false,
      // 是否已阅读注意事项
      sfyd: false,
      // 评价条数
      pjNum: 0,
      // 评价弹出层
      dialogVisible: false,
      tableData: [],
      theadData: [
        { name: "序号", code: "index", width: 60, align: "center" },
        { name: "评价内容", code: "a", slotName: "pjnr" },
        { name: "评价星级", code: "a", slotName: "pjxj" },
        { name: "评价时间", code: "pcHandlingGuidelineSuggestionTime" },
      ],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      zxDialogVisible: false,
    };
  },
  mounted() {
    const { code } = this.$route.query;
    if (code === undefined) {
      // 当前连接地址不正确，请联系管理员
      this.$message({
        type: "warning",
        message: "当前连接地址不正确，请联系管理员",
      });
      return;
    }
    this.guidelineCode = code;
    // this.znDom = document.querySelectorAll('h2.bsznTit')
    this.getGuideLine();
    window.addEventListener("scroll", this.initHeight);
    this.oLeft = document.querySelector(".bsContent").offsetLeft;
    // 窗口放大缩小
    window.onresize = () => {
      this.oLeft = document.querySelector(".bsContent").offsetLeft;
      this.initHeight();
    };
    this.globalAddVisit(code);
  },
  methods: {
    /**
     * @name pjFunc
     * @description 点击打开评价弹出层
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-03 17:39:45
     */
    pjFunc() {
      this.tableData = [];
      this.totalSize = 0;
      this.getPjList();
      this.dialogVisible = true;
    },
    /**
     * @name getPjList
     * @description 获取评价列表
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-03 17:48:18
     */
    async getPjList() {
      request({
        method: "get",
        url: "/portal-ywtb/web/guidelineSuggestion/findSuggestionDetailsListByCode",
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          guidelineCode: this.guidelineData.portalPcHandlingGuidelineCode,
        },
      })
        .then((res) => {
          let list = res.dataList || [];
          list.map((item, index) => {
            item.index = this.pageSize * (this.currentPage - 1) + index + 1;
            item.pcHandlingGuidelineSuggestionTime = this.globalDateFormat({
              time: item.pcHandlingGuidelineSuggestionTime,
              format: "yyyy-MM-dd hh:mm:ss",
            });
          });
          this.tableData = list;
          this.totalSize = res.count;
        })
        .catch((err) => {});
    },
    /**
     * @name handleCurrentChange
     * @description 切换当前页码
     * @param {}
     * @return {】}
     * @author cjs1992
     * @date 2020-08-04 08:56:05
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPjList();
    },
    /**
     * @name handleSizeChange
     * @description 切换每页条数
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-04 08:56:40
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    guideNavClick(index) {
      // this.guideIndex = index
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //判断滚动条是否到底儿了
      if (
        scrollHeight > clientHeight &&
        scrollTop + clientHeight === scrollHeight
      ) {
        this.guideIndex = index;
      }

      let distance = this.znDom[index].offsetTop + 150;
      window.scrollTo({
        top: distance,
        behavior: "smooth",
      });
    },
    initHeight() {
      //滚动条到页面顶部的距离
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      // let bsTab = document.querySelector(".bsTab");
      // if (scrollTop > this.bsTabOffsetTop) {
      //   this.isFixed = true;
      //   bsTab.style.left = this.oLeft + "px";
      // } else {
      //   this.isFixed = false;
      //   bsTab.style.left = 0;
      // }
      // for (let index = 0; index < this.znDom.length; index++) {
      //   if (this.znDom[index].offsetTop <= scrollTop - 150) {
      //     this.guideIndex = index;
      //   }
      // }
      // 处理吸附效果
      this.setStickyFunc();
    },
    /**
     * @name setStickyFunc
     * @description 处理吸附效果
     * @param {}
     * @author cjs
     * @date 2021-11-19 11:16:42
     */
    setStickyFunc() {
      /**
       * 检查元素是否存在cls这个名字的class
       * @private
       */
      function hasClass(obj, cls) {
        return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
      }
      /**
       * 为元素添加class
       * @private
       */
      function addClass(obj, cls) {
        if (!hasClass(obj, cls)) obj.className += " " + cls;
      }
      /**
       * 删除元素中的class
       * @private
       */
      function removeClass(obj, cls) {
        if (hasClass(obj, cls)) {
          var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          obj.className = obj.className.replace(reg, " ");
        }
      }
      const ref = this.$refs["sticky-ref"];
      const bounding = ref.getBoundingClientRect();
      const { top } = bounding;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 132) {
        addClass(ref, "sticky-wrap");
      } else {
        removeClass(ref, "sticky-wrap");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    downloadFile(name, path) {
      if (path.startsWith("http")) {
        top.window.location = path;
        return;
      }
      window.location =
        "/portal-ywtb/public/downloadFile?fileName=" +
        encodeURIComponent(path) +
        "&realFileName=" +
        name;
    },
    /**
     * @name checkLogin
     * @description 获取是否登录状态
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-03 11:09:35
     */
    async checkLogin() {
      return new Promise((resolve, reject) => {
        ywtbRequest("/portal-ywtb/web/getSession").then((res) => {
          localStorage.setItem("res", JSON.stringify(res));
          this.$store.commit("changeLogin");
          if (res.status === 200) {
            // 已登录
            resolve(1);
          } else {
            reject();
          }
        });
      });
    },
    async zxSubmit() {
      if (this.sfyd === false) {
        this.$message({
          type: "warning",
          message: "请阅读注意事项，并勾选已阅读",
        });
        return;
      }
      // 调用getSession判断是否登录
      try {
        await this.checkLogin();
      } catch (error) {
        // 获取当前页面的scrollTop
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        top.window.location =
          "/portal-ywtb/web/login?url=" + location.href + "?top=" + scrollTop;
        return;
      }
      if (this.zxText == "") {
        this.$message({
          message: "内容不能为空",
          type: "warning",
        });
        return;
      }
      let sendData = qs.stringify({
        content: this.zxText,
        guidelineCode: this.guidelineCode,
        memberId: this.$store.state.userId,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/consultation/addConsultation",
        sendData
      ).then((res) => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.zxText = "";
        this.sfyd = false;
        this.zxDialogVisible = false;
      });
    },
    //获取事项信息
    getGuideLine() {
      let sendData = qs.stringify({
        portalHandlingGuidelineCode: this.guidelineCode,
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guideline/getPortalHandlingGuideline",
        sendData
      ).then((res) => {
        let data = res.data;
        // 评分
        let scoreList = data.suggestionList;
        this.pjNum = scoreList.length || 0;
        let totalScore = 0;
        if (data.portalPcHandlingGuidelineCollection == 0) {
          this.isCollection = false;
        } else if (data.portalPcHandlingGuidelineCollection == 1) {
          this.isCollection = true;
        }
        if (scoreList.length > 0) {
          for (let i = 0; i < scoreList.length; i++) {
            totalScore +=
              scoreList[i].pcHandlingGuidelineSuggestionSatisfaction;
          }
          this.value = totalScore / data.suggestionList.length;
        } else {
          this.value = 0;
        }
        // 判断该有哪些
        let arr = [
          {
            name: "基本信息",
          },
          // {
          //   name: '事项说明'
          // },
          // {
          //   name: '资料下载'
          // },
          // {
          //   name: '文件规定'
          // },
          // {
          //   name: '常见问题'
          // },
          // {
          //   name: '我要咨询'
          // }
        ];
        let obj = {
          portalPcHandlingGuidelineGuideline: "事项说明",
          attachmentList: "资料下载",
          portalPcHandlingGuidelineFileRule: "文件规定",
          knowledgeList: "常见问题",
          portalPcHandlingGuidelineConsultation: "我要咨询",
        };
        for (let key in obj) {
          if (Object.prototype.toString.call(data[key]) === "[object Array]") {
            if (data[key].length > 0) {
              arr.push({ name: obj[key] });
            }
          } else if (data[key]) {
            arr.push({ name: obj[key] });
          }
        }
        // arr.push({
        //   name: '我要咨询'
        // });
        this.guideNav = arr;
        this.guidelineData = data;
        try {
          this.guidelineData.attachmentList =
            this.guidelineData.attachmentList.filter((item) => {
              if (
                item.pcHandlingGuidelineAttachmentPath === "" &&
                String(item.pcHandlingGuidelineAttachmentName).trim() === ""
              ) {
                return false;
              }
              return true;
            });
        } catch (error) {
          // 数据有误，不予处理
        }
        // 处理协办部门
        try {
          const str = this.guidelineData.assistDepartmentList
            .map((item) => item.deptName)
            .join("，");
          this.$set(this.guidelineData, "xbbm", str);
        } catch (error) {
          // 无需理会
        }
        this.$nextTick(() => {
          this.znDom = document.querySelectorAll("h2.bsznTit");
          let st = this.$route.query.top;
          if (st) {
            window.scrollTo({
              top: st,
              behavior: "smooth",
            });
            this.$router.replace({
              path: this.$route.path,
            });
          }
        });
      });
    },
    // 收藏和取消收藏
    collection() {
      let sendData = qs.stringify({
        collectionGuidelineCode: this.guidelineCode,
      });
      let url;
      if (!this.isCollection) {
        url = "/portal-ywtb/web/collection/addCollection";
      } else {
        url = "/portal-ywtb/web/collection/deleteCollection";
      }
      this.ywtbRequest(url, sendData).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.isCollection = !this.isCollection;
      });
    },
    //点击咨询
    goToZx() {
      this.zxDialogVisible = true;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.initHeight);
  },
};
</script>
<style src="./wangEditor.css"></style>
<style scoped>
/* 一网通办详情 */
.guideline-wrap {
  height: 121px;
  padding: 6px 30px;
  background-color: #fff;
  position: relative;
}
.sticky-wrap {
  position: fixed;
  top: 0;
  width: 1200px;
  z-index: 999;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.3);
}
.overView {
  background-color: #fff;
  height: 121px;
  /* padding: 6px 30px; */
  /* position: relative; */
  overflow: hidden;
  margin-top: 15px;
}

.is_fixed {
  position: fixed !important;
  z-index: 999;
}

.btn-primary {
  border-color: #2e6da4;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}

.table > tbody > tr > td {
  padding: 10px 8px;
  border: 1px solid #ddd;
}

.overView h2 {
  font-weight: 700;
  font-size: 22px;
  line-height: 62px;
}

.bsContent {
  margin-top: 17px;
  padding-top: 10px;
  background-color: #fff;
  width: 100%;
  padding-bottom: 10px;
  /* padding-left: 150px; */
  position: relative;
}

.bsTab {
  position: absolute;
  left: 0;
  top: 38px;
  border-right: 1px solid #d2d5e0;
  padding: 0px;
  width: 119px;
}

.bsTab li {
  width: 118px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-weight: 700;
  margin-bottom: 30px;
  transition: all 0.3s;
}

.bsTab li.active {
  color: #4772bd;
}

.bsTab li.active::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -2px;
  background: #4772bd;
  width: 4px;
  height: 22px;
}

.bsContent .content {
  /* display: none; */
  padding: 20px 58px;
  /* min-height: 500px; */
}

.bsContent .content div {
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.bsContent .content.active {
  display: block;
}

.fileDownload li {
  line-height: 46px;
  padding: 0 30px 0 15px;
  border-bottom: 1px solid #f0f0f0;
}

.fileDownload li .download {
  color: #157b70;
  cursor: pointer;
}

.fileDownload li:hover {
  background-color: #f8f8f8;
}

.fileDownload li:hover .download {
  color: #53b838;
}

/* .content3 > p {
line-height: 36px;
color: #999;
} */

textarea {
  width: 100%;
  height: 118px;
  resize: none;
  padding: 10px 20px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-top: 15px;
}

.bsScore strong {
  line-height: 37px;
}

.setScore {
  margin: 0 15px;
}

.setScore li.active {
  color: #ffca18;
}

.setScore li i {
  font-size: 26px;
}

#bsSubmit {
  padding: 8px 19px;
  margin-top: 20px;
}

.categoryBox .cate {
  /* position: relative; */
  padding: 0 15px;
  margin: 15px 0;
}

.categoryBox .cate > span {
  /* font-size: 16px; */
  float: left;
  font-weight: 700;
  line-height: 48px;
  width: 90px;
  text-align: center;
}

.categoryBox .cate > ul {
  float: left;
  width: 1040px;
}

.content0 img,
.content1 img {
  max-width: 100% !important;
}

.bsContent .content1 * {
  font-size: 16px !important;
  font-family: "microsoft yahei" !important;
}

.nullData {
  text-align: center;
  display: none;
}

.nullData img {
  width: 200px;
}

.nullData p {
  font-size: 16px;
  text-align: center;
}

.zixunTit {
  font-weight: 700;
  line-height: 36px;
  padding-left: 10px;
  color: #4772bd;
  position: relative;
  border-bottom: 1px solid #eaeaea;
}

.zixunTit > a {
  width: 93px;
  line-height: 32px;
  text-align: center;
  background-color: #4772bd;
  color: #fff;
  display: inline-block;
  position: absolute;
  top: -17px;
  right: 0;
}

.zixunContent {
  margin: 10px 0 20px 0;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 10px;
}

.fqzx {
  /* display: none; */
}

.zixun {
  margin-top: 10px;
}

.huifu {
  margin-top: 6px;
  /* height: 88px;
overflow: hidden; */
  padding-left: 15px;
}

#zxTextarea {
  width: 100%;
  height: 118px;
  resize: none;
  padding: 10px 20px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-top: 15px;
}

#hfTextarea,
#tshfTextarea {
  margin: 10px 30px;
  width: 600px;
  height: 118px;
  resize: none;
  padding: 10px 20px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-top: 15px;
}

#zxSubmit,
#hfSubmit,
#tsSubmit {
  padding: 8px 19px;
  margin-top: 20px;
  background-color: #4772bd;
  border-color: #4772bd;
}

.content6 .que,
.content6 .ans {
  line-height: 30px;
}

.content6 .que {
  color: #2d64b3;
}

#hfSubmit,
#tshfSubmit {
  margin-left: 30px;
}

.repayName {
  color: #2d64b3;
  padding: 0 5px;
}

.huifu li {
  line-height: 22px;
  color: #777;
}

.huifu li:nth-child(n + 4) {
  display: none;
}

.huifu.expand li:nth-child(n + 3) {
  display: block;
}

.checkMoreRelpay,
.checkMoreTsRelpay {
  /* font-size: 12px; */
  color: #999;
  padding-left: 13px;
  margin-top: 20px;
  /* width: 180px; */
  margin-right: 20px;
  display: inline-block;
}

.zixun > span {
  font-weight: 700;
}

.replayBtn {
  display: inline-block;
  cursor: pointer;
  color: #2d64b3;
}

.checkMoreRelpay span,
.checkMoreTsRelpay span {
  cursor: pointer;
  color: #2d64b3;
}

.bsznTit {
  width: 100%;
  height: 40px;
  padding: 4px 30px 0 10px;
  margin: 20px auto 0px;
  cursor: pointer;
  font-weight: 700;
}

.bsznTit span {
  padding-left: 12px;
  color: #272727;
  font-size: 18px;
}

.bsznTit img {
  float: right;
  width: 32px;
  height: 32px;
  cursor: pointer;
  opacity: 0.8;
  display: none;
}

.bsznTit .iconfont {
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #4772bd;
  line-height: 32px;
  color: #fff;
  text-align: center;
  font-weight: normal;
}

.overView .setScore li i {
  font-size: 16px;
}

.overView .bsScore .scoreText {
  line-height: 29px;
  margin-left: 10px;
}

.overView .setScore {
  margin: 2px 0 0 0;
  width: 180px;
  /* height: 16px; */
  /* background: url(../../assets/images/pf.png); */
}

.setScore /deep/ .el-rate__icon {
  font-size: 24px;
}

.overView .setScore .pf1 {
  width: 100%;
  height: 16px;
  overflow: hidden;
}

.setScore li {
  float: left;
  margin-right: 2px;
  color: #ccc;
  cursor: pointer;
}

.setScore1 li:nth-child(-n + 1) {
  color: #ffca18;
}

.setScore2 li:nth-child(-n + 2) {
  color: #ffca18;
}

.setScore3 li:nth-child(-n + 3) {
  color: #ffca18;
}

.setScore4 li:nth-child(-n + 4) {
  color: #ffca18;
}

.setScore5 li:nth-child(-n + 5) {
  color: #ffca18;
}

.ywtbCollection {
  padding-left: 24px;
  padding-top: 3px;
  color: #bebaba;
  cursor: pointer;
}

.ywtbCollection.active {
  color: #666;
}

.ywtbCollection.active .iconfont {
  color: #ffca1a;
}

.overView .btnGroup {
  position: absolute;
  right: 64px;
  width: 85px;
  top: 8px;
}

.overView .btnGroup a {
  margin-top: 10px;
  width: 121px;
  height: 38px;
  border-radius: 4px;
  padding: 8px 12px;
  border-radius: 4px;
}

.overView .btnGroup .blBtn {
  color: #fff;
  background-color: #4772bd;
  display: none;
}

.overView .btnGroup .pjBtn {
  color: #4772bd;
  background-color: #fff;
}

/* 一网通办详情 */
.jbxx table tr td {
  padding-left: 30px;
}

.jbxx table tr td:nth-of-type(odd) {
  background-color: #eff2fa;
  width: 158px;
}

.jbxx table tr td:nth-of-type(even) {
  width: 290px;
}

.table.fileDownload tr:first-child td {
  background: #eff2fa;
}

.table.fileDownload td {
  text-align: center;
}

.table.fileDownload tr:not(:first-child) td:last-child {
  text-decoration: underline;
  color: #4772bd;
  cursor: pointer;
}

.zxContent ul {
  padding-left: 10px;
}

.zxContent ul li {
  margin: 10px 0;
}

.zxContent ul li > h4 b {
  color: #4772bd;
  font-weight: normal;
  margin-left: 5px;
  cursor: pointer;
}

.zxContent ul li .replayContent {
  padding-left: 22px;
  margin-top: 10px;
  display: none;
}

.zxContent ul li .replayContent > div {
  line-height: 22px;
  color: #666;
}

.ywtbCollection .icon-sc.active {
  color: rgb(247, 186, 42);
}
.zd_class {
  width: 40px;
  height: 23px;
  line-height: 22px;
  /* background: url(../../../static/images/newBg.png) no-repeat 0px 0px; */
  background-color: #f00;
  float: left;
  text-align: center;
  color: #fff;
  margin-left: 6px;
}
.btn-wrap {
  float: right;
  display: flex;
}
.btn-wrap a {
  margin-right: 8px;
}
.btn-wrap a:last-child {
  margin-right: 0;
}

.overView .btn-wrap .blBtn {
  color: #fff;
  background-color: #4772bd;
  display: none;
  width: 121px;
  height: 38px;
  border-radius: 4px;
  padding: 8px 12px;
}

.overView .btn-wrap .pjBtn {
  color: #4772bd;
  background-color: #fff;
  width: 60px;
  height: 38px;
  border-radius: 4px;
  padding: 8px 12px;
}

.dialog /deep/ .el-dialog__title {
  font-weight: bold;
  font-size: 16px;
  text-align: left;
  color: #000;
}
.dialog /deep/ .el-dialog__header {
  padding: 20px 20px 0;
}
.dialog /deep/ .el-dialog__body {
  padding: 0 20px;
  font-size: 12px;
}
.el-checkbox {
  font-size: 12px !important;
  text-align: left;
  color: #e6a23c;
}
.el-checkbox /deep/ span .el-checkbox__label {
  font-size: 12px !important;
}
/deep/ .el-checkbox .el-checkbox__label {
  font-size: 12px !important;
}
.btn-zx {
  width: 552px;
  height: 38px;
  border-radius: 4px;
  background: #2e6da4;
  margin-bottom: 14px;
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/MattersGuide.vue